import React from 'react';
import PropTypes from 'prop-types';
import {
    HOSTAPP,
    TransitionBanner,
} from '@homeaway/react-brand-transition-banner';
import Experiment from '@homeaway/react-experiment';

export default class TransitionBannner extends React.Component {
    static propTypes = {
        systemData: PropTypes.shape({}),
    };

    static defaultProps = {
        systemData: {},
    };

    render() {
        const {systemData} = this.props;
        return (
            <React.Fragment>
                <Experiment name={'HA_GX_PRE_BRAND_TRANSITION'} variant={'on'}>
                    <TransitionBanner
                        forPreTransition
                        hostApp={HOSTAPP.TX}
                        locale={systemData.fullLocale}
                        siteName={systemData.site?.name}
                    />
                </Experiment>
                <Experiment name={'HA_GX_POST_BRAND_TRANSITION'} variant={'on'}>
                    {systemData.hasQueryParam && (
                        <TransitionBanner
                            forPreTransition={false}
                            hostApp={HOSTAPP.TX}
                            locale={systemData.fullLocale}
                            siteName={systemData.site?.name}
                            useCookie={false}
                            vgdc={systemData.vgdc}
                        />
                    )}
                </Experiment>
            </React.Fragment>
        );
    }
}
